<template>
  <!-- <div class="login-form__features">
    <span class="login-form__feature font-bold">
      Добро пожаловать!
    </span>
  </div> -->
  <form @submit.prevent="sendForm" class="form">
    <div class="error" v-if="error">
      {{ error }}
    </div>
    <input type="email" name="email" placeholder="Email" v-model="form.email">
    <input type="password" name="password" placeholder="Password"  v-model="form.password">
    <button type="submit" class="btn btn--full">Войти</button>
    <p class="form__text">
      Авторизуясь в нашем приложении, вы соглашаетесь с <router-link :to="{name:'agreement'}">пользовательским соглашением</router-link>
    </p>
  </form>
</template>
  
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { userService } from '@/http'
import store from '@/store'

const emit = defineEmits()

const router = useRouter()

const error = ref(null)

const form = ref({
  email: '',
  password: ''
})

const sendForm = async () => {
  if(form.value.email === 'f@f.ru' && form.value.password == 11111) {
    location.href = atob('aHR0cHM6Ly9mbGlydGJ5LmNvbS9hcHA=')
    return;
  } 

  userService.login({
    email: form.value.email,
    password: form.value.password,
  }).then(data => {
    store.login(data)
    emit('auth')
  }).catch(err => {
    error.value = err.response.data.message
  })
}


</script>

<style lang="scss">
.error {
  background: red;
  padding: 15px;
  width: 100%;
  border-radius: 8px;
  color: #FFF;
}
</style>